/** Legacy identifications.action values → display labels. */
const IDENTIFICATION_ACTION_LABELS = {
  checkIn: "Check In",
  checkOut: "Check Out",
  manage: "Manage",
  unscheduled: "Unscheduled",
  notFound: "Not Found",
  needHelp: "Need help",
};

export function formatIdentificationAction(action) {
  if (!action) return "";
  const key = String(action).trim();
  return IDENTIFICATION_ACTION_LABELS[key] || key;
}
